import { useEffect, useState } from 'react';
import PermissionMatrix from '../PermissionMatrix/PermissionMatrix';
import { getRoleUsers, getUsers, assignUser, removeUser } from '../../api/roleApi';
import './RoleDetail.css';

function UserPickerModal({ roleId, assignedIds, onClose, onAssigned }) {
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    getUsers().then(users => {
      setAllUsers(users.filter(u => !assignedIds.includes(u._id)));
    });
  }, [assignedIds]);

  const pick = async (userId) => {
    await assignUser(roleId, userId);
    onAssigned();
    onClose();
  };

  return (
    <div className="user-picker-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="user-picker-panel">
        <div className="user-picker-panel__header">
          <span className="user-picker-panel__title">Assign User</span>
          <button className="role-detail__close" onClick={onClose}>{'\u2715'}</button>
        </div>
        {allUsers.length === 0 && (
          <div className="user-picker-panel__empty">No unassigned users available.</div>
        )}
        {allUsers.map(u => (
          <div key={u._id} className="user-picker-panel__item" onClick={() => pick(u._id)}>
            <div className="role-detail__avatar" style={{ background: u.color || '#004358' }}>
              {u.name.charAt(0)}
            </div>
            <div>
              <div className="role-detail__user-name">{u.name}</div>
              <div className="role-detail__user-email">{u.email}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function RoleDetail({ role, onClose, onChanged }) {
  const [users, setUsers] = useState([]);
  const [showPicker, setShowPicker] = useState(false);

  const loadUsers = () => {
    getRoleUsers(role._id).then(setUsers).catch(() => {});
  };

  useEffect(() => { loadUsers(); }, [role._id]);

  const handleRemove = async (userId) => {
    if (!window.confirm('Remove this user from the role?')) return;
    await removeUser(role._id, userId);
    loadUsers();
    onChanged();
  };

  return (
    <div className="role-detail-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="role-detail-panel">
        <div className="role-detail-panel__header">
          <div>
            <div className="role-detail-panel__title">{role.name}</div>
            <div className="role-detail-panel__badge-wrap">
              <span className={`role-detail__badge ${role.is_protected ? 'role-detail__badge--protected' : 'role-detail__badge--custom'}`}>
                {role.is_protected ? 'Protected' : 'Custom'}
              </span>
            </div>
          </div>
          <button className="role-detail__close" onClick={onClose}>{'\u2715'}</button>
        </div>

        <div className="role-detail-panel__body">
          {role.description && (
            <p className="role-detail-panel__desc">{role.description}</p>
          )}

          <div className="role-detail__section-label">Permission Matrix</div>
          <PermissionMatrix permissions={role.permissions} onChange={() => {}} readOnly={true} />

          <div className="role-detail__divider" />
          <div className="role-detail__users-header">
            <div className="role-detail__section-label">
              Assigned Users ({users.length})
            </div>
            <button className="btn btn--primary btn--sm" onClick={() => setShowPicker(true)}>+ Add User</button>
          </div>

          {users.length === 0 && (
            <div className="role-detail__empty">No users assigned to this role.</div>
          )}

          {users.map(u => (
            <div key={u._id} className="role-detail__user-row">
              <div className="role-detail__avatar" style={{ background: u.color || '#004358' }}>
                {u.name.charAt(0)}
              </div>
              <div>
                <div className="role-detail__user-name">{u.name}</div>
                <div className="role-detail__user-email">
                  {u.email}{u.team ? ` \u00B7 ${u.team} Team` : ''}
                </div>
              </div>
              <button className="role-detail__remove-btn" onClick={() => handleRemove(u._id)}>Remove</button>
            </div>
          ))}
        </div>
      </div>

      {showPicker && (
        <UserPickerModal
          roleId={role._id}
          assignedIds={users.map(u => u._id)}
          onClose={() => setShowPicker(false)}
          onAssigned={() => { loadUsers(); onChanged(); }}
        />
      )}
    </div>
  );
}
